import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const TaxHouseholdCompositionSummary = props => {
    const {
        family: {
            allHhmAttributes: {
                common,
                individual
            }
        },
        isState
    } = props;
    
    const intl = useIntl();

    const getHhmsInfo = () => {
        return individual.map((individualAttributes, idx) => {
            const {
                partnerRelationshipTextId,
                status
            } = individualAttributes;

            const formattedPartnerRelationship = intl.formatMessage({ id: partnerRelationshipTextId });
            const partnerRelationship = isState.NM ? formattedPartnerRelationship.toLowerCase() : formattedPartnerRelationship;
            return (
                <p key = { idx } >
                    <FormattedMessage
                        id = { `ssap.family_household.tax_composition.brief_info_${status}` }
                        values = { {
                            ...common,
                            ...individualAttributes,
                            partnerRelationship
                        } }
                    />
                </p>
            );
        });
    };

    return (
        <div className = 'usa-alert usa-alert--info gi-alert gi-alert__info' >
            <div className = 'usa-alert__body gi-alert__info__body' >
                <p className = 'usa-alert__text gi-alert__info__text' >
                    <FormattedMessage id = 'ssap.family_household.tax_composition.based_on_info' />
                </p>
                { getHhmsInfo() }
                <p key = 'disclaimer'>
                    <FormattedMessage id = 'ssap.family_household.tax_composition.disclaimer' />
                </p>
            </div>
        </div>
    );
};

export default TaxHouseholdCompositionSummary;